import { IonButton, IonItem, IonLabel } from '@ionic/react';
import moment from 'moment';
import {
} from "../utilities/ApiTasks";
export const BookingRow = ({color, item, history}) => {
  const formatDate = (date) => {
    return moment(date).format('DD MMM YY');
  };

    function formatGuestCounts(item) {
        const counts = [
            { label: 'A', value: item.adults },
            { label: 'C', value: item.children },
            { label: 'I', value: item.infants },
            { label: 'P', value: item.pets },
        ];

        return counts
            .filter(({ value }) => value > 0)
            .map(({ label, value }) => `${value}${label}`)
            .join(' | ');
    }

  return (
      <IonItem
          button={true}
          color={color}
          lines='none'
          onClick={(e) => {
              e.stopPropagation();
              history.push(`/booking/${item.id}`);
          }} detail
      >
        <IonLabel>
          <h3>
            <strong>{item.id} - {formatDate(item.fromdate)} - {formatDate(item.todate)}</strong>
          </h3>
          <h3>
            {item.property.name}
          </h3>
          <h3>
            {item?.customers ? `${item.customers[0].name}` : `${item.guesttype}`}
            {formatGuestCounts(item) && ` • ${formatGuestCounts(item)}`}
          </h3>
        </IonLabel>

        <IonButton
            fill='clear'
            size='small'
            onClick={(e) => {
              e.stopPropagation();
              history.push(`/booking/${item.id}`);
            }}
        >
        </IonButton>
      </IonItem>
  );
};